import React from "react";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const VehicleDrawerHeader = ({
  theme,
  mode,
  operationName,
  selectedVehicleDetails,
  onSearchToggle,
  onAddMode,
  onBackToList,
  onClose,
  isSearchActive
}) => (
  <div className={`GM__${theme}-vehicle-drawer-header`}>
    <div className={`GM__${theme}-drawer-title-container`}>
      {(mode === "add" || mode === "details") && (
        <IconButton
          onClick={onBackToList}
          className={`GM__${theme}-back-button`}
        >
          <KeyboardBackspaceIcon />
        </IconButton>
      )}
      <h2 className={`GM__${theme}-drawer-title`}>
        {mode === "list"
          ? `Vehículos - ${operationName || "Operación"}`
          : mode === "add"
          ? "Añadir Vehículos"
          : `Detalles - ${selectedVehicleDetails?.plate || ""}`}
      </h2>
    </div>
    <div className={`GM__${theme}-drawer-header-actions`}>
      {mode === "list" && (
        <>
          <IconButton 
            onClick={onSearchToggle} 
            className={`GM__${theme}-search-button ${isSearchActive ? 'active' : ''}`}
          >
            <SearchIcon />
          </IconButton>
          <IconButton
            onClick={onAddMode}
            className={`GM__${theme}-add-button`}
          >
            <AddIcon />
          </IconButton>
        </>
      )}
      <IconButton onClick={onClose} className={`GM__${theme}-close-button`}>
        <CloseIcon />
      </IconButton>
    </div>
  </div>
);

export default React.memo(VehicleDrawerHeader);